"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toPoint = toPoint;
function toPoint(point, inverted = false) {
  let lat, lng;
  if (typeof point === 'string') {
    const coords = point.split(',').map(ele => parseFloat(ele));
    [lng, lat] = inverted ? coords.reverse() : coords;
  } else if ('lat' in point) {
    ({
      lat,
      lng
    } = point);
  } else {
    [lng, lat] = point.coordinates;
  }
  return {
    lat,
    lng
  };
}